"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Streetview = exports.CSS = void 0;
const mithril_component_1 = require("../../components/mithril.component");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
exports.CSS = {
    wrapper: 'c-StreetviewWrapper',
};
const Style = {
    [exports.CSS.wrapper]: {
        height: '100%',
        width: '100%',
    },
};
(0, theme_1.addStyles)(Style);
class Streetview extends mithril_component_1.IMithrilComponent {
    constructor() {
        super(...arguments);
        this.panorama = null;
    }
    onCreate(vnode) {
        this.panorama = services_1.Services.Streetview.attach(vnode.dom);
    }
    get nodes() {
        return (0, mithril_1.m)('div', {
            className: exports.CSS.wrapper,
        });
    }
}
exports.Streetview = Streetview;
//# sourceMappingURL=streetview.js.map